import "./NewsIssues.scss";
import DateInput from "@/components/Common/DateInput/DateInput.vue";
import NewsIssuesList from "@/components/News/NewsIssuesList/NewsIssuesList.vue";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
import { generateImageFromPdf, getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
import moment from "moment";
import { uploadFile } from "@/helpers/fileHelper";
import { DateTime } from "luxon";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "NewsIssues",
  components: { DateInput, NewsIssuesList },

  data: () => ({
    dialog: false,
    headers: [
      { text: "Titel", value: "title" },
      { text: "Status", value: "status" },
      { text: "Bearbeitungsende", value: "deadline_date" },
      { text: "Erscheinungsdatum", value: "release_date" },
      { text: "Geändert", value: "change_date" },
      {
        text: "Aktionen",
        value: "actions",
        sortable: false,
        align: "center",
        width: "5%"
      }
    ],
    editedItem: {
      change_date: "",
      create_date: "",
      deadline_date: "",
      release_date: "",
      status: "open",
      title: "",
      pdf_file: {
        title: "",
        url: ""
      },
      cover_image_file: {
        url: "",
        title: "",
        generate_from_pdf: true
      },
      visibility_date_widget: {
        from: "",
        to: ""
      }
    },
    defaultItem: {
      change_date: "",
      create_date: "",
      deadline_date: "",
      release_date: moment().toISOString(),
      status: "open",
      title: "",
      pdf_file: {
        title: "",
        url: ""
      },
      cover_image_file: {
        url: "",
        title: "",
        generate_from_pdf: true
      },
      visibility_date_widget: {
        from: "",
        to: ""
      }
    },
    monthArray: [],
    month: "",
    yearArray: [],
    year: "",
    statusArray: [],
    status: "",
    filter: {},
    editLoading: false
  }),
  async mounted() {
    if (!this.isAdmin && !this.isNewsAdmin) {
      return await this.$router.push(`/news/`);
    }
    this.filterOptions();
    await this.loadIssues();
  },
  computed: {
    formTitle() {
      return this.editedItem.isNew ? "Ausgabe anlegen" : "Ausgabe bearbeiten";
    },
    currentPrincipal() {
      return this.$store.state.selectedPrincipal.id;
    },
    principals() {
      return this.$store.state.principals ?? [{}];
    },
    isAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:admin");
    },
    isNewsAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:news_admin");
    },
    total() {
      return this.issues?.length;
    },
    issues() {
      return this.$store.state.issues;
    },
    isValid() {
      return this.editedItem?.title?.length && this.deadlineOptionOk;
    },
    deadlineOptionOk() {
      return (
        this.editedItem?.release_date &&
        this.editedItem?.release_date > this.editedItem?.deadline_date
      );
    }
  },
  methods: {
    async createError(error) {
      this.$store.dispatch("createError", error);
    },
    async createSuccess(successMessage) {
      this.$store.dispatch("createSuccess", successMessage);
    },
    async loadIssues() {
      this.filter.principal_id = this.currentPrincipal;
      this.filter.month = this.month;
      this.filter.year = this.year;
      this.filter.status = this.status;
      try {
        await this.$store.dispatch("getIssues", this.filter);
      } catch (err) {
        this.$emit("createError", err);
      }
    },
    filterOptions() {
      const currentYear = Number(new Date().getFullYear());
      this.yearArray = [currentYear - 1, currentYear, currentYear + 1];
      this.year = currentYear;

      this.monthArray = [
        { value: "0", title: "Januar" },
        { value: "1", title: "Februar" },
        { value: "2", title: "März" },
        { value: "3", title: "April" },
        { value: "4", title: "Mai" },
        { value: "5", title: "Juni" },
        { value: "6", title: "Juli" },
        { value: "7", title: "August" },
        { value: "8", title: "September" },
        { value: "9", title: "Oktober" },
        { value: "10", title: "November" },
        { value: "11", title: "Dezember" }
      ];
      this.statusArray = [
        { value: "open", title: "Offen" },
        { value: "closed", title: "Geschlossen" },
        { value: "revison", title: "In Revision" }
      ];
    },
    createItem() {
      this.editedIndex = -1;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedItem.isNew = true;
      this.editedItem.principal_id = this.currentPrincipal;
      this.dialog = true;
    },
    editItem(item) {
      this.editedIndex = this.issues.indexOf(item);
      this.editedItem = Object.assign({ ...this.defaultItem }, item);
      this.editedItem.isNew = false;
      this.dialog = true;
    },
    deleteItem(item) {
      this.$confirm(
        `Sind Sie sicher, dass Sie 
        <br>"${item.title}" löschen wollen?`,
        confirmWarningConfig
      ).then(async res => {
        if (res) {
          try {
            await this.deleteIssue(item);
          } catch (err) {
            this.createError(err);
            return;
          }
          this.editedIndex = this.issues.indexOf(item);
          this.editedItem = Object.assign({}, item);
          this.issues.splice(this.editedIndex, 1);
          this.closeDelete();
        }
      });
    },
    async deleteIssue(item) {
      const title = item.title;
      const params = {
        principal_id: this.currentPrincipal
      };
      const headers = getTokenHeader(),
        res = await axios.delete(
          `${env.news_api_client_url}issue/${item._id}`,
          {
            headers,
            params
          }
        );
      if (res.status === 200) {
        this.createSuccess(title + " gelöscht!");
      } else {
        this.createError({ ...res, text: item.title + " nicht gelöscht!" });
      }
    },
    afterSave(close) {
      if (this.editedIndex > -1) {
        Object.assign(this.issues[this.editedIndex], this.editedItem);
      } else {
        this.issues.push(this.editedItem);
      }
      this.loadIssues();
      if (close) {
        this.close();
      }
      this.createSuccess("Erfolgreich gespeichert!");
    },
    close() {
      this.editedItem = { ...this.defaultItem };
      this.dialog = false;

      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    closeDelete() {
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    generateImageFromPdf,
    async generateCoverImage() {
      return await this.generateImageFromPdf(
        this.editedItem.pdf_file.url,
        this.editedItem.title
      );
    },
    async save(close) {
      if (this.$refs.editForm.validate()) {
        let success = false;
        this.loadingStatus(true);
        try {
          this.editedItem.pdf_file = await this.saveFile(
            this.editedItem.pdf_file
          );
          if (
            this.editedItem.pdf_file?.url &&
            this.editedItem.cover_image_file.generate_from_pdf
          ) {
            if (!this.editedItem.cover_image_file?.url) {
              const coverImageFile = await this.generateCoverImage();
              await this.addCoverImageFile(coverImageFile);
            }
          }
          this.editedItem.cover_image_file = await this.saveFile(
            this.editedItem.cover_image_file
          );
          if (
            this.editedItem.release_date &&
            !this.editedItem.visibility_date_widget.from
          ) {
            this.editedItem.visibility_date_widget.from = DateTime.fromISO(
              this.editedItem.release_date
            )
              .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
              .toISO();
          }
          success = this.editedItem.isNew
            ? await this.createIssue()
            : await this.updateIssue();
          if (success) {
            this.afterSave(close);
          }
        } catch (ex) {
          this.createError(ex);
        }
        this.loadingStatus(false);
      } else {
        this.createError({
          text: "Nicht gespeichert! Bitte alle Pflichtfelder überprüfen!"
        });
      }
    },
    async updateIssue() {
      const headers = getTokenHeader(),
        res = await axios.put(
          `${env.news_api_client_url}issue`,
          this.editedItem,
          { headers }
        );
      return res.status === 200;
    },
    async createIssue() {
      const headers = getTokenHeader(),
        res = await axios.post(
          `${env.news_api_client_url}issue`,
          this.editedItem,
          { headers }
        );
      this.editedItem.isNew = false;
      this.editedItem._id = res.data._id;
      return res.status === 200;
    },
    loadingStatus(status) {
      this.editLoading = status;
    },
    async addPdfFile(e) {
      if (!e) {
        this.editedItem.pdf_file = {};
        this.editedItem.cover_image_file.generate_from_pdf = false;
        return;
      }

      const file = e?.dataTransfer?.files ?? e ?? false;
      if (!file) {
        this.editedItem.pdf_file = {};
        this.editedItem.cover_image_file.generate_from_pdf = false;
        return;
      }

      file.dataUrl = await this.readFileUrl(file);
      file.title = file.name;
      this.editedItem.pdf_file = file;
    },
    async addCoverImageFile(e) {
      if (!e) {
        this.editedItem.cover_image_file = {};
        return;
      }

      const file = e?.dataTransfer?.files ?? e ?? false;
      if (!file) {
        this.editedItem.cover_image_file = {};
        return;
      }

      file.dataUrl = await this.readFileUrl(file);
      file.title = file.name;
      this.editedItem.cover_image_file = file;
      this.editedItem.cover_image_file.generate_from_pdf = true;
    },
    readFileUrl(file) {
      return new Promise((resolve, reject) => {
        if (file) {
          const reader = new FileReader();
          reader.onload = ({ target }) => {
            if (target?.result) resolve(target.result);
            else reject("Unable to read File");
          };
          reader.readAsDataURL(file);
        } else reject("No file passed");
      });
    },
    async saveFile(file) {
      if (!file.url && file.dataUrl) {
        const res = await fetch(file.dataUrl);
        const blob = await res.blob();
        blob.filename = file.name;
        const newFile = await uploadFile(
          blob,
          this.editedItem.id || this.editedItem._id,
          "news",
          this.editedItem.principal_id,
          progressEvent => {
            this.createSuccess(
              Math.round((progressEvent.loaded * 100) / progressEvent.total) +
                " % hochgeladen.."
            );
          }
        );
        file = {
          url: newFile.url,
          title: newFile.title,
          generate_from_pdf: file.generate_from_pdf
        };
      }
      return file;
    }
  }
};
